module.exports = __webpack_public_path__ + "img/home-brand-barilla.png?dd40a6f27d9ea1b7711d1cdcf6e8fd06";